module.exports = __webpack_public_path__ + "static/media/employer_details_icon copy.db591d79.svg";